<script setup lang="ts">
const t2 = useT2({
  'View details': 'Peržiūrėti',
})

defineProps<{
  link?: boolean
  viewlabel?: stringI18n
  small?: boolean
}>()

const mobile = useMobile()
</script>

<template>
  <div :class="[$style.split, link && ['ButtonIcon', 'IconArrow']]">
    <div :class="[$style.top, mobile ? '_glass bg' : undefined]">
      <slot name="top" />

      <div v-if="link || (!mobile && $slots.topright)" class="_row _ctrY _mla" :class="mobile && [$style.arrM, '_absolute']">
        <slot v-if="!mobile" name="topright" />
        <ButtonIcon v-if="link" :txt="viewlabel || t2('View details')">
          <IconArrow class="_svg20" />
        </ButtonIcon>
      </div>
      <slot v-if="mobile" name="topright" />
    </div>

    <div :class="[$style.left, $clsClass('UiBox123'), !small && '_hm140']">
      <slot name="left" />
    </div>

    <div :class="$style.right">
      <slot name="right" />
    </div>

    <slot name="bottom" />
  </div>
</template>

<style module>
.arrM {
  composes: global(_br99);
  composes: global(_b5);
  composes: global(_bg0);

  top: 4px;
  right: 4px;
}

.split {
  composes: global(_row);
  composes: global(m_col);
  composes: global(_wrap);
  composes: global(d_br14);
  composes: global(_hidden);
  composes: global(_flex);
}
:global(.d) .split {
  border: 1px solid var(--bg);
}

.top {
  composes: global(_relative);
  composes: global(_row);
  composes: global(_ctrY);
  composes: global(_wrap);
  composes: global(d_gap3);

  composes: global(m_h28);

  composes: global(_pt04);
  composes: global(_pb04);
  composes: global(_pl08);

  composes: global(d_ml06);
  composes: global(d_mr06);

  composes: global(m_pt1);
  composes: global(m_pb1);
  composes: global(m_pr4);
  composes: global(m_pl1);
  composes: global(m_gap1);

  composes: global(_noflex);
  composes: global(_hm40);
}

:global(.d) .top {
  width: calc(100% - 14px);
}
:global(.m) .top {
  gap: 10px 20px;
}
.top:after {
  content: '';
  height: 1px;
  width: 100%;
  background: var(--tb, var(--black-5));
  border-radius: 9px;
  position: absolute;
  bottom: 0;
  left: 0;
}
:global(.UiBox123):hover .top {
  --tb: var(--black);
}
.left {
  composes: global(_col);
  composes: global(m_pt2);
  composes: global(m_pb2);
  composes: global(m_pl1);
  composes: global(m_pr1);
  composes: global(d_pt2);
  composes: global(d_pb1);
  composes: global(d_pl14);
  composes: global(d_gap2);
  composes: global(m_gap3);
  composes: global(_noflex);
  composes: global(_w50p);
}
.right {
  composes: global(_col);
  composes: global(m_pb1);
  composes: global(d_pt1);
  composes: global(d_pb1);
  composes: global(d_pl14);
  composes: global(d_pr14);
  composes: global(_gap2);
  flex: 1 0 50%;
}
</style>
